
import React, { useContext } from 'react';
import I18n from 'i18n-js';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { RCButton, buttonClassName } from '@reverbdotcom/cadence/components';
import { Field } from '../sellFormReducer';
import { SellFormContext } from '../SellFormContext';
import { Paths } from '../../../shared/url_helpers';

interface IProps {
  disabled?: boolean;
}

export function SellFormPublish({ disabled }: IProps) {
  const { formState, loading, setIsSubmitting } = useContext(SellFormContext);
  const id = (!loading && formState) ? formState[Field.ID] : undefined;

  if (loading || !id || disabled) {
    return (
      <RCButton disabled onClick={() => {}} variant="primary">
        {I18n.t('discovery.sellForm.section.publish')}
      </RCButton>
    );
  }

  const submitUrl = id ? Paths.listingSubmit.expand({ query: { id: formState[Field.ID], react_sell_form_publish: true } }) : '';

  return (
    <CoreLink
      to={submitUrl}
      className={buttonClassName({ variant: 'primary' })}
      onClick={() => setIsSubmitting(true)}
    >
      {I18n.t('discovery.sellForm.section.publish')}
    </CoreLink>
  );
}
